// extracted by mini-css-extract-plugin
export default {"mCard":"ZC-z","image":"_C-z","imageNoBackground":"aD-z","imageHasCategory":"bD-z","fullWidth":"cD-z"};